import { render } from "./OdgovoriTab.vue?vue&type=template&id=640a2e32&scoped=true"
import script from "./OdgovoriTab.vue?vue&type=script&lang=js"
export * from "./OdgovoriTab.vue?vue&type=script&lang=js"

import "./OdgovoriTab.vue?vue&type=style&index=0&id=640a2e32&scoped=true&lang=css"

import exportComponent from "/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-640a2e32"]])

export default __exports__
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QList,QItem,QItemSection,QItemLabel});qInstall(script, 'directives', {Ripple});
